import { useCallback } from 'react';
import { useParams } from 'react-router';
import { ShiftTypeService } from 'src/api/ShiftTypeService';
import { invalidateShiftTypes } from '@stores/shiftTypeStore';

type DeleteShiftType = (shiftTypeId: string) => Promise<true>;

const useDeleteShiftType = (): { deleteShiftType: DeleteShiftType } => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const deleteShiftType = useCallback<DeleteShiftType>(
        async (shiftTypeId) => {
            if (!departmentId) {
                throw new Error(
                    'useDeleteShiftType requires a departmentId route param',
                );
            }

            const isDeleted = await ShiftTypeService.deleteShiftType(
                departmentId,
                shiftTypeId,
            );

            invalidateShiftTypes(departmentId);

            return isDeleted;
        },
        [departmentId],
    );

    return { deleteShiftType };
};

export default useDeleteShiftType;
